export const MentionSharedCssClassName = {
	MENTION_CONTAINER: 'mentionView-content-wrap',
};
